// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import history from '../../../../services/history';
import { Button } from '../../../../components';
import { getBasket } from '../../store/selectors';
import styles from './styles';

class Checkout extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    checkoutForTradeCustomer: PropTypes.func,
    total: PropTypes.object,
    basket: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    checkoutForTradeCustomer: () => { },
    total: {},
    basket: [],
  };

  onCheckout = () => {
    const logged = localStorage.getItem('loggedID');
    const tradeCustomer = JSON.parse(localStorage.getItem('TradeCustomer'));
    const { checkoutForTradeCustomer, total } = this.props;

    if (logged) {
      const items = this.props?.basket.map((item) => {
        return {
          item_id: item.EAN,
          item_name: item.Title,
          currency: 'GBP',
          price: item.SellbackPrice,
          quantity: 1
        };
      });

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          items
        }
      });

      if (tradeCustomer) {
        localStorage.setItem('total', JSON.stringify(total));
        checkoutForTradeCustomer();
      } else {
        history.push('/checkout');
      }
    } else {
      history.push({
        pathname: '/login',
        state: { checkout: true }
      });
    }
  }

  render() {
    const { classes } = this.props;
    const textTopRegular = 'Congratulations you have reached your minimum order level';
    const textBottomBold = 'Continue adding items or checkout';

    return (
      <div className={classes.mainContainer}>
        <div className={classes.textContainer}>
          <span className={classes.textTop}>{textTopRegular}</span>
          <span className={classes.textBottom}>{textBottomBold}</span>
        </div>
        <Button
          text={'checkout'}
          style={classes.buttonStyle}
          onPress={this.onCheckout}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    basket: getBasket(state),
  };
}

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(Checkout));
